import React from 'react';

import AmexIcon from '../../../../assets/icons/cards/Amex.svg';
import MastercardIcon from '../../../../assets/icons/cards/Mastercard.svg';
import VisaIcon from '../../../../assets/icons/cards/Visa.svg';
import SecureIcon from '../../../../assets/icons/header/checkout/secure.svg';
import CartDark from '../../../../assets/icons/miniBasket/CartDark.svg';
import ReceiptIcon from '../../../../assets/icons/miniBasket/Receipt.svg';

interface MiniBasketMobileViewProps {
    open: boolean;
    isOpen?: boolean;
    subtotal: number;
    formatPrice: (amount: number) => string;
    handleCheckout: () => void;
    handleViewFullBasket: () => void;
}

const MiniBasketMobileView: React.FC<MiniBasketMobileViewProps> = ({
    open,
    isOpen,
    subtotal,
    formatPrice,
    handleCheckout,
    handleViewFullBasket,
}) => {
    if (!open && !isOpen) return null;

    return (
        <div className="md:hidden fixed bottom-0 left-0 right-0 w-full bg-[#F9FAFB] z-[60] border-t border-[#EAECF0] p-[20px] pb-[max(20px,env(safe-area-inset-bottom))] flex flex-col gap-0 box-border">
            {/* Row 1: Sub Total + Price */}
            <div className="flex justify-between items-center w-full h-[26px] mb-0">
                <span className="font-noto font-semibold text-[14px] leading-[20px] text-[#182230]">Sub Total:</span>
                <span className="font-noto font-semibold text-[18px] leading-[26px] text-[#182230] text-right">{formatPrice(subtotal)}</span>
            </div>

            {/* Row 2: Tax Text */}
            <div className="text-left text-[12px] text-[#667085] font-noto font-normal leading-[18px] mb-[12px]">
                + tax and discount applied at checkout
            </div>

            {/* Row 3: Buttons (Stacked) */}
            <div className="flex flex-col gap-[8px] w-full">
                <button
                    onClick={handleCheckout}
                    className="w-full h-[40px] bg-[#030407] text-white rounded-[6px] font-bold font-noto flex items-center justify-center gap-[6px] text-[12px] leading-[18px]"
                >
                    <span className="text-[12px] font-bold text-white">Checkout</span>
                    <img src={SecureIcon} alt="Secure" className="w-[20px] h-[20px] brightness-0 invert" />
                </button>
                <button
                    onClick={handleViewFullBasket}
                    className="w-full h-[40px] bg-white text-[#101828] border border-[#667085] rounded-[6px] font-bold font-noto flex items-center justify-center gap-[6px] text-[12px] leading-[18px]"
                >
                    <span className="text-[12px] font-bold text-[#101828]">View Full Basket</span>
                    <img src={CartDark} alt="" className="w-[20px] h-[20px]" />
                </button>
            </div>

            {/* Row 4: We Accept Icons (Centered) */}
            <div className="flex items-center justify-center gap-[12px] mt-[16px] h-[24px]">
                <span className="text-[12px] text-[#667085] font-noto font-normal leading-[18px]">We accept:</span>
                <div className="flex gap-[4px]">
                    <img src={MastercardIcon} alt="Mastercard" className="w-[23px] h-[16px]" />
                    <img src={AmexIcon} alt="Amex" className="w-[23px] h-[16px]" />
                    <img src={VisaIcon} alt="Visa" className="w-[23px] h-[16px]" />
                    <div className="w-[23px] h-[16px] border border-gray-200 rounded-[2px] flex items-center justify-center bg-white">
                        <img src={ReceiptIcon} alt="Invoice" className="h-[10px] w-auto" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MiniBasketMobileView;
